import {
  Box,
  Flex,
  HStack,
  Progress,
  Stack,
  Text,
  Tooltip
} from '@chakra-ui/react';
import { ReactNode } from 'react';
import { AiOutlineInfoCircle } from 'react-icons/ai';

import { OdontoIcon } from '../../assets/icons/OdontoIcon';
import { PrevidenciaIcon } from '../../assets/icons/PrevidenciaIcon';
import { SaudeIcon } from '../../assets/icons/SaudeIcon';
import { VidaIcon } from '../../assets/icons/VidaIcon';

type ProductCardProps = {
  title: string;
  value?: number;
  info?: ReactNode;
  rep?: number;
};

const handleIcon = (type: string) => {
  switch (type) {
    case 'Saúde':
      return <SaudeIcon w="2rem" h="2.375rem" />;
    case 'Odonto':
      return <OdontoIcon w="2rem" h="2.375rem" />;
    case 'Vida':
      return <VidaIcon w="2rem" h="2.375rem" />;
    case 'Previdência':
      return <PrevidenciaIcon w="2rem" h="2.375rem" />;
    default:
      return '';
  }
};

export const ProductCard = ({ title, value, info, rep }: ProductCardProps) => {
  return (
    <Stack
      bg="#fff"
      w="11.25rem"
      boxShadow="0px 0px 5px rgba(50, 50, 50, 0.25)"
      borderRadius="24px"
      padding={'1.25rem'}
    >
      <Box display="flex" justifyContent="flex-start" flexDir="column">
        <Box display="flex" justifyContent="space-between">
          <Box display="flex" gap=".3rem">
            <Text fontWeight="bold" fontSize="1rem">
              {title}
            </Text>
            {info ? (
              <Tooltip label={info} shouldWrapChildren>
                <AiOutlineInfoCircle size={14} />
              </Tooltip>
            ) : null}
          </Box>

          <Box>{handleIcon(title)}</Box>
        </Box>

        <Text fontSize=".85rem" pt="1rem">
          Prêmio emitido/mês
        </Text>
        <Text
          paddingBottom="1.25rem"
          fontSize="1.25rem"
          fontWeight="bold"
          color="#146CFA"
        >
          R$ {value?.toLocaleString('pt-br')}
        </Text>
        {rep ? (
          <>
            <Text fontSize=".85rem" pt="1rem">
              Repr. na produção total
            </Text>
            <Box
              display="flex"
              w="100%"
              justifyContent="space-between"
              alignItems="center"
            >
              <Progress w="80%" borderRadius="1rem" value={rep}></Progress>
              <Text color="#828282" fontWeight="540">
                {rep}%
              </Text>
            </Box>
          </>
        ) : (
          <Flex
            background={'#D3DEED'}
            padding={'0.3rem 0'}
            justify={'space-around'}
            alignItems={'center'}
            borderRadius=".3rem"
            width={'100%'}
          >
            <AiOutlineInfoCircle color="#323232bd" size={30} />
            <Text color={'#323232'}>
              Repr. menor <br /> que 1%
            </Text>
          </Flex>
        )}
      </Box>
    </Stack>
  );
};
